module.exports = __webpack_public_path__ + "static/media/achatdansmaville-site.824ae511.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/achatdansmaville-site.png
// module id = 65
// module chunks = 0